"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BanksList = void 0;
var react_1 = __importDefault(require("react"));
var BankList_module_scss_1 = __importDefault(require("./BankList.module.scss"));
var selectors_1 = require("../../redux/selectors");
var ErrorLoading_1 = require("../errorLoading/ErrorLoading");
var getBankImage_1 = require("../../helpers/bank/getBankImage");
var react_router_dom_1 = require("react-router-dom");
var convertToUrl_1 = require("../../helpers/convertToUrl");
var Loader_1 = require("../loader/Loader");
var banksListSlice_1 = require("../../redux/slice/banksListSlice");
var react_redux_1 = require("react-redux");
var BanksList = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var banksList = (0, react_redux_1.useSelector)(selectors_1.banksListSelector).banksList;
    var isLoad = (0, react_redux_1.useSelector)(selectors_1.banksListSelector).stateLoad.isLoad;
    var error = (0, react_redux_1.useSelector)(selectors_1.banksListSelector).stateLoad.error;
    var selectBank = function (bankId) { return dispatch((0, banksListSlice_1.setTargetBankId)(bankId)); };
    if (error) {
        return react_1.default.createElement(ErrorLoading_1.ErrorLoading, null);
    }
    if (isLoad) {
        return react_1.default.createElement(Loader_1.Loader, null);
    }
    return (react_1.default.createElement("ul", { className: BankList_module_scss_1.default.banks_list }, banksList.map(function (_a) {
        var name = _a.name, id = _a.id;
        return (react_1.default.createElement("li", { className: BankList_module_scss_1.default.banks_list__item, key: id },
            (0, getBankImage_1.getBankImage)(name) ? (react_1.default.createElement("img", { loading: "lazy", className: BankList_module_scss_1.default.banks_list__img, src: (0, getBankImage_1.getBankImage)(name), alt: name })) : (react_1.default.createElement("div", null, name)),
            react_1.default.createElement("div", { className: BankList_module_scss_1.default.banks_list__helper },
                react_1.default.createElement("p", null, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"),
                react_1.default.createElement("p", null,
                    "\u0432 ",
                    name)),
            react_1.default.createElement(react_router_dom_1.Link, { className: BankList_module_scss_1.default.banks_list__link, to: "/credit/".concat((0, convertToUrl_1.convertToUrl)(name)), onClick: function () { return selectBank(id); } })));
    })));
};
exports.BanksList = BanksList;
